// Auto-generated enum from table vwClaims

export const claimName = {
    adminImageInfo_Show: 'adminImageInfo_Show',
    billingSettings_Read: 'billingSettings_Read',
    billingSettings_Update: 'billingSettings_Update',
    btnDeletedList_Show: 'btnDeletedList_Show',
    btnFallbackPhotoEdit_Show: 'btnFallbackPhotoEdit_Show',
    btnImageDetails_Show: 'btnImageDetails_Show',
    btnListAdd_Show: 'btnListAdd_Show',
    btnListDeleteDeep_Show: 'btnListDeleteDeep_Show',
    btnListRestore_Show: 'btnListRestore_Show',
    btnListShare_Show: 'btnListShare_Show',
    btnMainPhotoEdit_Show: 'btnMainPhotoEdit_Show',
    btnPageCancel_Show: 'btnPageCancel_Show',
    btnPageDelete_Show: 'btnPageDelete_Show',
    btnPageDetails_Show: 'btnPageDetails_Show',
    btnPageEdit_Show: 'btnPageEdit_Show',
    btnPageLock_Show: 'btnPageLock_Show',
    btnPageSave_Show: 'btnPageSave_Show',
    btnTabEdit_Show: 'btnTabEdit_Show',
    btnTabSave_Show: 'btnTabSave_Show',
    creditType_Read: 'creditType_Read',
    creditType_Update: 'creditType_Update',
    generalData_Update: 'generalData_Update',
    logo_Delete: 'logo_Delete',
    logo_Update: 'logo_Update',
    logoEmail_Delete: 'logoEmail_Delete',
    logoEmail_Update: 'logoEmail_Update',
    logoIcon_Delete: 'logoIcon_Delete',
    logoIcon_Update: 'logoIcon_Update',
    mainPhoto_Update: 'mainPhoto_Update',
    membershipPolicy_Update: 'membershipPolicy_Update',
    ownerData_Update: 'ownerData_Update',
    page_Delete: 'page_Delete',
    page_Delete_Deep: 'page_Delete_Deep',
    page_Read: 'page_Read',
    page_Restore: 'page_Restore',
    page_Update: 'page_Update',
    photo_Update: 'photo_Update',
    superiorData_Read: 'superiorData_Read',
    superiorData_Update: 'superiorData_Update',
    tab_Delete: 'tab_Delete',
    tab_Read: 'tab_Read',
    tab_Update: 'tab_Update',
    twoFactor_Update: 'twoFactor_Update',
    twoFactorPolicy_Update: 'twoFactorPolicy_Update',
}

export type TClaimName = (typeof claimName)[keyof typeof claimName];

